import ApiService from '../../../../shared/services/ApiService';

export default {
    get(){
     return ApiService.get('company-ptos')
    },
    newPto(data){
        return ApiService.post('company-ptos-multi', data);
    },
    deletePto(id){
        return ApiService.delete(`company-ptos/${id}`);
    },
    editPto(id, data) {
        return ApiService.put(`company-ptos/${id}`, data);
    },
    getPtoTypes(labels) {
        return [
            { value: 1, label: labels.get('paid') },
            { value: 2, label: labels.get('unpaid') }
        ];
    }
}